module.exports = __webpack_public_path__ + "img/elec_bottom3_us.428101b3.png";